import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import iconEmpty from 'icons/createproject/supportneed.svg'
import {
  Button,
  Drawer,
  Form,
  Input,
  Table,
  Space,
  Alert,
  Row,
  Col,
  Switch,
  InputNumber,
  Select,
  Modal,
} from 'antd'
//checkrole
import { CounterContext } from 'redux/Golbalvalues'
import { PlusOutlined, SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { getCookie } from 'helper/cookie'
import DeleteAdfsBtn from 'common/Management/delete'
import { isEmpty, toUpper } from 'lodash'
import lang from 'lang/en'
import TextArea from 'antd/lib/input/TextArea'
import { addAdfs, getResultAdfs, updateAdfs } from 'api/MasterData/custumAdfs'
const CustumAdfsContainer = styled.div``
const EmptyContainer = styled.div``
const Container = styled.div``
const Header = styled.div``
const Body = styled.div``
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
`

const InputNumberCustom = styled(InputNumber)`
  .ant-input-number-handler-wrap {
    visibility: hidden !important;
  }
`

const initalState = {
  data: [],
  isLoading: true,
  pagination: {
    pageSize: 10, //จำนวนข้อมูลในหน้านั้น
    total: 0, //ข้อมูลทั้งหมด
    current: 1,
    showQuickJumper: 1,
    // showSizeChanger: true,
    // showTotal: (total, range) => showToalPagination(total, range),
  },
}
let wordError = ''
const showToalPagination = (total, range) => {
  return <p className='small-show-total'>{`${range[0]}-${range[1]} of ${total}`}</p>
}
const AuthADFS = () => {
  const token = getCookie('access_token_admin')
  const language = getCookie('lang')
  const word = lang[language]
  const [dataAdfs, setDataAdfs] = useState(initalState.data)
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [pagination, setPagination] = useState(initalState.pagination)
  const [visible, setVisible] = useState(false)
  const [stateDrawer, setStateDrawer] = useState('')
  const [titleDrawer, setTitleDrawer] = useState('')
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [dataEdit, setDataEdit] = useState()
  const [hiddenError, setHiddenError] = useState(true)
  const [statusActive, setStatusActive] = useState(true)
  const [dataInputDomains, setDataInputDomains] = useState('')
  const [idItemAdfs, setIdItemAdfs] = useState(0)

  //search
  const [searchedColumn, setSearchedColumn] = useState('')
  const [searchText, setSearchText] = useState('')
  const [form] = Form.useForm()

  //checkrole
  const { adminPermission } = useContext(CounterContext)
  //check permission
  const [disablePage, setDisablePage] = useState(false)

  const [permissionPage, setPermissionPage] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  })

  const roleUser = getCookie('roleUser')

  useEffect(() => {
    if (roleUser == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        create: true,
        read: true,
        update: true,
        delete: true,
      }))
    } else {
      adminPermission.map((item) => {
        if (item.menu_id == 17) {
          setPermissionPage((prevState) => ({
            ...prevState,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      })
    }
  }, [adminPermission])

  // call data business
  const getDataAdfs = async () => {
    await getResultAdfs({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataAdfs([])

          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataAdfs(data)
          setIsLoading(false)
        } else {
          setDataAdfs([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataAdfs([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      getDataAdfs()
    }
  }, [token])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type='primary'
            className='mini-search-btn-admin'
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          >
            <SearchOutlined className='icon' />
            Search
          </Button>
          <Button
            type='primary'
            className='mini-search-btn-admin-reset'
            onClick={() => handleReset(clearFilters)}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    render: (text) => (searchedColumn === dataIndex ? text : text),
  })

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const columns = [
    {
      title: <h5>Name</h5>,
      dataIndex: 'title',
      sorter: (a, b) => a.title.localeCompare(b.title),
      ellipsis: true,
      ...getColumnSearchProps('title'),
    },
    {
      title: <h5>Email domains</h5>,
      dataIndex: 'email_domain',
      sorter: (a, b) => a.email_domain.localeCompare(b.email_domain),
      ellipsis: true,
      ...getColumnSearchProps('email_domain'),
    },
    {
      title: <h5>Client id</h5>,
      dataIndex: 'client_id',
      sorter: (a, b) => a.client_id.localeCompare(b.client_id),
      ellipsis: true,
      ...getColumnSearchProps('client_id'),
    },
    {
      title: <h5>Tenant id</h5>,
      dataIndex: 'tenant_id',
      sorter: (a, b) => a.tenant_id.localeCompare(b.tenant_id),
      ellipsis: true,
      ...getColumnSearchProps('tenant_id'),
    },
    {
      title: <h5>Status</h5>,
      dataIndex: 'status',
      sorter: (a, b) => a.status.localeCompare(b.status),
      ellipsis: true,
      ...getColumnSearchProps('status'),
    },
  ]

  const dataSource = dataAdfs?.data?.map((item) => ({
    id: item.id,
    title: item.title,
    email_domain: item.email_domain,
    client_id: item.client_id,
    client_secret: item.client_secret,
    tenant_id: item.tenant_id,
    forgot_url: item.forgot_url,
    firstname_attr: item.firstname_attr,
    lastname_attr: item.lastname_attr,
    compcode_attr: item.compcode_attr,
    phone_attr: item.phone_attr,
    status: item.status,
    created_at: item.created_at,
    updated_at: item.updated_at,
  }))

  const onFinish = (value) => {
    if (stateDrawer === 'add') {
      const data = {
        title: value.name,
        email_domain: String(dataInputDomains),
        client_id: value.client_id,
        client_secret: value.client_secret,
        tenant_id: value.tenant_id,
        forgot_url: value.forget_password_url,
        firstname_attr: value.first_name_en_ext_attr_number,
        lastname_attr: value.last_name_en_ext_attr_number,
        compcode_attr: value.main_company_code_ext_attr_number,
        phone_attr: value.phone_ext_attr_number,
        status: statusActive ? 'active' : 'nonactive',
      }
      try {
        addAdfs({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setHiddenError(true)
            getDataAdfs()
            setVisible(false)
          } else {
            if (res.data.errorCode === '2008') {
              wordError = 'Email domains already in the system'
            } else {
              wordError = 'error'
            }
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else {
      const data = {
        id: idItemAdfs,
        title: value.name,
        email_domain: String(dataInputDomains),
        client_id: value.client_id,
        client_secret: value.client_secret,
        tenant_id: value.tenant_id,
        forgot_url: value.forget_password_url,
        firstname_attr: value.first_name_en_ext_attr_number,
        lastname_attr: value.last_name_en_ext_attr_number,
        compcode_attr: value.main_company_code_ext_attr_number,
        phone_attr: value.phone_ext_attr_number,
        status: statusActive ? 'active' : 'nonactive',
      }
      try {
        updateAdfs({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            setHiddenError(true)
            getDataAdfs()
            setVisible(false)
          } else {
            if (res.data.errorCode === '2008') {
              wordError = 'Email domains already in the system'
            } else {
              wordError = 'error'
            }
            setHiddenError(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }

  const eventAdd = () => {
    form.setFieldsValue({
      name: null,
      email_domains: undefined,
      client_id: null,
      client_secret: null,
      tenant_id: null,
      forget_password_url: null,
      first_name_en_ext_attr_number: null,
      last_name_en_ext_attr_number: null,
      main_company_code_ext_attr_number: null,
      phone_ext_attr_number: null,
    })
    setStatusActive(true)
    setHiddenError(true)
    setVisible(true)
    setStateDrawer('add')
    setTitleDrawer('Add Adfs')
  }

  const eventEdit = (data) => {
    permissionPage.update ? setDisablePage(false) : setDisablePage(true)
    let splitEmailDomains = data?.email_domain.split(',')
    form.setFieldsValue({
      name: data.title,
      email_domains: splitEmailDomains,
      client_id: data.client_id,
      client_secret: data.client_secret,
      tenant_id: data.tenant_id,
      forget_password_url: data.forgot_url,
      first_name_en_ext_attr_number: data.firstname_attr,
      last_name_en_ext_attr_number: data.lastname_attr,
      main_company_code_ext_attr_number: data.compcode_attr,
      phone_ext_attr_number: data.phone_attr,
    })

    if (data.status === 'Active') {
      setStatusActive(true)
    } else {
      setStatusActive(false)
    }
    setIdItemAdfs(data.id)
    setDataInputDomains(splitEmailDomains)
    setHiddenError(true)
    setDataEdit(data)
    setStateDrawer('edit')
    setTitleDrawer('Edit Adfs')
    setVisible(true)
  }

  function onChange(pagination2, filters, sorter, extra) {
    if (pagination !== false) {
      setPagination((prevState) => {
        return {
          ...prevState,
          pageSize: pagination2.pageSize,
          current: pagination2.current,
        }
      })
    }
  }

  const renderButton_Drawer = () => {
    if (stateDrawer === 'add') {
      return (
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Button className='BTN_Next' onClick={form.submit}>
            {word['Save']}
          </Button>
        </div>
      )
    } else {
      return (
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Button
            className='BTN_Delete_CPF_RED'
            onClick={() => setVisibleDelete(true)}
            style={{ marginRight: 8 }}
            hidden={permissionPage.delete ? false : true}
          >
            {word['Delete']}
          </Button>
          <Button
            hidden={permissionPage.update ? false : true}
            className='BTN_Next'
            onClick={form.submit}
            type='primary'
          >
            {word['Save']}
          </Button>
        </div>
      )
    }
  }

  const onClose = () => {
    setVisible(false)
  }

  const content = () => {
    if (dataAdfs?.data?.length > 0) {
      return (
        <Container>
          <Header className='layout-button-add-normal-state'>
            <div className='layout-btn-reset-add'>
              <Button
                id='add'
                onClick={eventAdd}
                icon={<PlusOutlined className='Icon-color' />}
                className='BTN_Next'
                hidden={permissionPage.create ? false : true}
              >
                Add Adfs Setting
              </Button>
              <Button
                id='reset'
                type='primary'
                style={{ marginLeft: 8 }}
                className='btn_Secondary2'
                onClick={() => window.location.reload()}
              >
                <RedoOutlined className='Icon-color' />
                {word['Reset']}
              </Button>
            </div>
          </Header>
          <Body>
            <Table
              key='business_table'
              onRow={(record) => {
                return {
                  onClick: () => eventEdit(record), // click row
                }
              }}
              columns={columns}
              dataSource={dataSource}
              onChange={onChange}
              pagination={pagination}
              showSorterTooltip={false}
            />
          </Body>
        </Container>
      )
    } else {
      return (
        <EmptyContainer className='initialstate-container'>
          <img src={iconEmpty} />
          <h2>Please add Adfs in your project (optional)</h2>
          <Button
            hidden={permissionPage.create ? false : true}
            id='add'
            onClick={eventAdd}
            icon={<PlusOutlined className='Icon-color' />}
            className='btn_Secondary2'
          >
            Add Adfs Setting
          </Button>
        </EmptyContainer>
      )
    }
  }

  const onChangeDomains = (e) => {
    if (isEmpty(e)) {
      setDataInputDomains(null)
    } else {
      const pattern = new RegExp(
        /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z]/,
      )
      e.forEach((item) => {
        if (!pattern.test(item)) {
          e.pop()
        }
        setDataInputDomains(e)
      })
    }
  }

  const validateForgetPasswordUrl = (_, value, callback) => {
    const validList = [
      {
        pattern: '^https?://',
        message: 'Please enter format https:// in the beginning.',
      },
    ]

    validList.forEach((regex) => {
      if (value && !value.match(regex.pattern)) {
        callback(regex.message)
      }
    })
    callback()
  }

  return (
    <CustumAdfsContainer
      style={{ padding: 32 }}
      className='layout-git-master-unitmeasurment'
    >
      {content()}
      <Modal
        maskClosable={false}
        title={<TextTitleBold>{titleDrawer}</TextTitleBold>}
        placement='right'
        onCancel={onClose}
        visible={visible}
        width={'634px'}
        className='fix-modal'
        footer={renderButton_Drawer()}
        destroyOnClose
        centered
      >
        <Form className='disable-page' form={form} layout='vertical' onFinish={onFinish}>
          <fieldset disabled={disablePage}>
            <div hidden={hiddenError} style={{ marginBottom: 10 }}>
              <Alert message={wordError} type='error' showIcon />
            </div>

            {/* name */}
            <Form.Item
              id='name'
              name='name'
              label={<h4>Name</h4>}
              className="customValidation"
              rules={[
                {
                  required: true,
                  message: 'Please enter name',
                },
              ]}
            >
              <Input id='name' size='large' placeholder='Please enter name' />
            </Form.Item>

            {/* Email Domains */}
            <Form.Item
              id='email_domains'
              name='email_domains'
              label={<h4>Email domains</h4>}
              className="customValidation"
              rules={[
                {
                  required: true,
                  message: 'Please enter email domains',
                },
              ]}
            >
              <Select
                size='large'
                mode='tags'
                open={false}
                placeholder='Please enter email domains'
                onChange={onChangeDomains}
                value={dataInputDomains}
              />
            </Form.Item>

            {/* Client ID */}
            <Form.Item
              id='client_id'
              name='client_id'
              label={<h4>Client id</h4>}
              className="customValidation"
              rules={[
                {
                  required: true,
                  message: 'Please enter client id',
                },
              ]}
            >
              <Input id='client_id' size='large' placeholder='Please enter client id' />
            </Form.Item>

            {/* Client Secret */}
            <Form.Item
              id='client_secret'
              name='client_secret'
              label={<h4>Client secret</h4>}
              className="customValidation"
              rules={[
                {
                  required: true,
                  message: 'Please enter client secret',
                },
              ]}
            >
              <Input
                id='client_secret'
                size='large'
                placeholder='Please enter client secret'
              />
            </Form.Item>

            {/* Tenant ID */}
            <Form.Item
              id='tenant_id'
              name='tenant_id'
              label={<h4>Tenant id</h4>}
              className="customValidation"
              rules={[
                {
                  required: true,
                  message: 'Please enter tenant id',
                },
              ]}
            >
              <Input id='tenant_id' size='large' placeholder='Please enter tenant id' />
            </Form.Item>

            {/* Forget Password Url */}
            <Form.Item
              id='forget_password_url'
              name='forget_password_url'
              label={<h4>Forget password url</h4>}
              className="customValidation"
              rules={[
                {
                  required: true,
                  message: 'Please enter forget password url',
                },
                {
                  validator: validateForgetPasswordUrl,
                },
              ]}
            >
              <TextArea
                id='forget_password_url'
                size='large'
                placeholder='Please enter forget password url (https://)'
              />
            </Form.Item>

            <Row gutter={16}>
              {/* First Name EN Ext Attr Number */}
              <Col span={12}>
                <Form.Item
                  id='first_name_en_ext_attr_number'
                  name='first_name_en_ext_attr_number'
                  label={<h4>First name en ext attr number</h4>}
                  className="customValidation"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter first name en ext attr number',
                    },
                  ]}
                >
                  <InputNumberCustom
                    min={0}
                    max={99}
                    type='number'
                    id='first_name_en_ext_attr_number'
                    size='large'
                    placeholder='Please enter first name en ext attr number'
                    style={{ height: '40px', width: '100% ' }}
                  />
                </Form.Item>
              </Col>

              {/* Last Name EN Ext Attr Number */}
              <Col span={12}>
                <Form.Item
                  id='last_name_en_ext_attr_number'
                  name='last_name_en_ext_attr_number'
                  label={<h4>Last name en ext attr number</h4>}
                  className="customValidation"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter last name en ext attr number',
                    },
                  ]}
                >
                  <InputNumberCustom
                    min={0}
                    max={99}
                    type='number'
                    id='last_name_en_ext_attr_number'
                    size='large'
                    placeholder='Please enter last name en ext attr number'
                    style={{ height: '40px', width: '100% ' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* Main Company Code Ext Attr Number */}
            <Form.Item
              id='main_company_code_ext_attr_number'
              name='main_company_code_ext_attr_number'
              label={<h4>Main company code ext attr number</h4>}
              className="customValidation"
              rules={[
                {
                  required: true,
                  message: 'Please enter main company code ext attr number',
                },
              ]}
            >
              <InputNumberCustom
                type='number'
                min={0}
                max={99}
                style={{ height: '40px', width: '100% ' }}
                id='main_company_code_ext_attr_number'
                size='large'
                placeholder='Please enter main company code ext attr number'
              />
            </Form.Item>

            {/* Phone Ext Attr Number */}
            <Form.Item
              id='phone_ext_attr_number'
              name='phone_ext_attr_number'
              label={<h4>Phone ext attr number</h4>}
              className="customValidation"
              rules={[
                {
                  required: true,
                  message: 'Please enter phone ext attr number',
                },
              ]}
            >
              <InputNumberCustom
                type='number'
                min={0}
                max={99}
                style={{ height: '40px', width: '100% ' }}
                id='phone_ext_attr_number'
                size='large'
                placeholder='Please enter phone ext attr number'
              />
            </Form.Item>

            {/* status active */}
            <Form.Item
              id='status_active'
              name='status_active'
              label={<h4>Status active</h4>}
            >
              <Switch defaultChecked={statusActive} onChange={setStatusActive} />
            </Form.Item>
          </fieldset>
        </Form>
        <DeleteAdfsBtn
          visibleDelete={visibleDelete}
          setVisibleDelete={setVisibleDelete}
          state={'auth_adfs'}
          data={dataEdit}
          renderData={getDataAdfs}
          setVisibleDrawer={setVisible}
        />
      </Modal>
    </CustumAdfsContainer>
  )
}
export default AuthADFS
